import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { changedElsewhere } from '@state/pile/actions';
import { workloadActions } from '@state/workload';

const CHECK_MS = 60_000;

/**
 * "Today", "Tomorrow" and the weekdays (utils/dayLabel) belong to a day, and so does the Overdue list: when a new day
 * starts while the page is open (in the term's time zone), the sidebar and the Task List read their tasks again, so
 * last night's "Tomorrow" doesn't stay. Checked every minute and as soon as the student comes back to the tab.
 */
export function useNewDayRefresh(active: boolean) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!active) return;

    let day = moment().format('YYYY-MM-DD');
    const check = () => {
      const today = moment().format('YYYY-MM-DD');
      if (today === day) return;
      day = today;
      dispatch(changedElsewhere());
      dispatch(workloadActions.getWorkload.request(undefined));
    };

    const interval = window.setInterval(check, CHECK_MS);
    document.addEventListener('visibilitychange', check);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', check);
    };
  }, [active, dispatch]);
}
